/**
 * Local vite-dev ports, as injected by the build.
 *
 * Why this exists: in local standalone dev each satellite runs its own vite
 * server on its own port, so a cross-app hop has to target the right one.
 * Production serves every app from one origin with no port, and the Docker dev
 * mode shares :3000 — neither ever consults this.
 *
 * NOTHING here is a literal. The port a satellite serves on is declared exactly
 * once, by that app's own `apps/<name>/vite.config.ts`; `frontend/devPortMap.ts`
 * reads those at build time and `frontend/vite.config.ts` injects them, only for
 * `vite dev`. A production build injects `''` and `{}`, so these fold to empty
 * and the port table is never shipped.
 *
 * This replaced two hand-maintained tables (sessionRouting.ts, mainAppUrl.ts)
 * that had drifted three ways: they listed 7 satellites while apps/ had 11, one
 * hardcoded the main port while the other read an env var, and both shipped to
 * production. Discovery from apps/ means a new satellite is routable in dev the
 * moment it has a vite config — there is no list left to go stale.
 */

/** The main frontend's dev port; empty string in production. */
export const MAIN_DEV_PORT: string = __MAIN_DEV_PORT__;

/**
 * Subdomain prefix ("alg.") → that app's dev port. Keyed by prefix because
 * routing resolves an agent to a subdomain first (config-driven), then needs
 * its port. Empty in production.
 */
export const DEV_PORT_BY_PREFIX: Record<string, string> = __DEV_PORT_BY_PREFIX__;

/**
 * The satellite dev ports, for the "am I on a sub-app?" check in the
 * bare-localhost dev setup, where there is no subdomain to strip. Empty in
 * production, so that check answers on the subdomain alone — the only signal
 * that exists there anyway.
 */
export const SUB_APP_DEV_PORTS = new Set(Object.values(DEV_PORT_BY_PREFIX));
